import { format } from "date-fns";

import { MonetaryAmount } from "app/domain/monetary-amount";
import { translate as t } from "infrastructure/translate/localization";

export function getColumns() {
  return [
    { id: "legalId", label: t("common-messages.nif-nie") },
    { id: "name", label: t("common-messages.name-and-surname") },
    {
      id: "activationDate",
      label: t("employees-section.remainingBalance.activationDate"),
    },
    {
      id: "limitAmount",
      label: t("employees-section.remainingBalance.balanceDelivered"),
    },
    {
      id: "remainingAmount",
      label: t("employees-section.remainingBalance.title"),
    },
  ];
}

function getAmountFormatted({ benefitBag, key }) {
  if (!benefitBag?.[key]) return "-";
  const amount = benefitBag?.[key]?.amountInCents || 0;
  const currency = benefitBag?.[key]?.currency || 0;
  return new MonetaryAmount(amount, currency).prettifyMoney({});
}

export function getData(data) {
  return data?.map(
    ({ id, legalId, name, activeSinceTimestamp, benefitBag }) => {
      const activationDate = activeSinceTimestamp
        ? format(activeSinceTimestamp * 1000, "dd/MM/yyyy")
        : "-";

      const remainingAmount = getAmountFormatted({
        benefitBag,
        key: "remainingAmount",
      });

      const limitAmount = getAmountFormatted({
        benefitBag,
        key: "limitAmount",
      });

      return {
        id,
        legalId,
        name,
        activationDate,
        limitAmount,
        remainingAmount,
      };
    }
  );
}
